module.exports = __webpack_public_path__ + "img/3.d2fa3007.jpg";